var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1FB9FC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.4,1c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4c3.2,0,5.7,2.6,5.7,5.7v23.1c-2.1-1.3-4.6-2.1-7.3-2.1 c-5.3,0-9.9,3-12.3,7.3c-1.4-0.7-2.9-1.2-4.5-1.2c-1.6,0-3.2,0.5-4.5,1.2c-2.4-4.3-7-7.3-12.3-7.3c-2.7,0-5.1,0.8-7.3,2.1V13.6 c0-3.2,2.6-5.7,5.7-5.7c1.9,0,3.4-1.5,3.4-3.4S15.5,1,13.6,1C6.6,1,1,6.6,1,13.6v35.2C1,56.7,7.3,63,15.2,63c7.3,0,13.2-5.5,14-12.6 h0.2c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7h0.2c0.8,7.1,6.7,12.6,14,12.6C56.7,63,63,56.7,63,48.8V13.6C63,6.6,57.4,1,50.4,1 z M15.2,56.1c-4,0-7.3-3.3-7.3-7.3c0-4,3.3-7.3,7.3-7.3s7.3,3.3,7.3,7.3C22.4,52.9,19.2,56.1,15.2,56.1z M48.8,56.1 c-4,0-7.3-3.3-7.3-7.3c0-4,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3C56.1,52.9,52.9,56.1,48.8,56.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.367b669cd43a634bf63aba5ed781f693.svg";
export { ForwardRef as ReactComponent };